import { createContext, RefObject } from 'react';

export const MenuButtonContext = createContext<{
  hideContextMenu: () => void;
  btnRef: RefObject<HTMLDivElement> | null;
}>({
  hideContextMenu: () => {},
  btnRef: null,
});
